<div class="progress-kolecko">
  <svg viewBox="0 0 100 100">
    <!-- background -->
    <circle
      class="bg"
      cx="50" cy="50"
      [attr.r]="radius">
    </circle>
    <!-- progress -->
    <circle
      class="progress"
      cx="50" cy="50"
      [attr.r]="radius"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="dashOffset">
    </circle>
  </svg>
  <span class="label" *ngIf="showLabel">{{ progress }}%</span>
</div>